<template>
  <form @submit.prevent="$emit('next')" class="selling-data col mt-9 mt-lg-0">
    <div v-if="form.status !== 'draft'">
      <bp-select
        v-model="form.status"
        label="Status de Vendas"
        placeholder="Selecionar..."
        id="sale-status"
        select
        :options="[
          { id: 'active', name: 'Ativas' },
          { id: 'inactive', name: 'Suspensas' }
        ]"
      />
    </div>

    <bp-input
      class="mt-5"
      v-model="form.email_support"
      id="email_support"
      label="E-mail de suporte ao cliente"
      type="email"
      description="Atenção! Seus compradores entrarão em contato com você através deste E-mail."
      placeholder="Digite um e-mail de suporte"
      :errors="errors.email_support"
    />

    <bp-input
      class="mt-5"
      v-model="form.statement_descriptor"
      id="statement_descriptor"
      label="Nome na fatura"
      type="name"
      placeholder="Digite um nome"
      description="Atenção! Insira um nome que descreva seu produto para evitar chargebacks."
      :errors="descErrors"
      :limit="13"
    />

    <hr class="my-6" />

    <span>Simulação da fatura</span>

    <div class="card border-light mt-6">
      <div class="card-body d-flex flex-column p-5">
        <span class="small-text text-secondary">23/02/2021</span>
        <div class="d-flex mt-6">
          <strong class="mr-5"
            >{{ $config.get("title") }}* {{ form.statement_descriptor }}</strong
          >
          <strong>R$ 189,90</strong>
        </div>
      </div>
    </div>

    <div class="d-none d-sm-flex justify-content-between mt-9">
      <button
        type="button"
        class="btn btn-outline-secondary"
        @click="$emit('cancel')"
      >
        Cancelar
      </button>
      <div class="mx-3"></div>
      <button
        type="submit"
        class="btn d-flex align-items-center"
        :class="isValid ? 'btn-primary ' : 'btn-secondary'"
        :disabled="!isValid"
      >
        Próximo
        <i class="icon-angle-right ml-3" />
      </button>
    </div>
    <div class="d-sm-none justify-content-between mt-9">
      <button
        type="submit"
        class="btn btn-block align-items-center"
        :class="isValid ? 'btn-primary ' : 'btn-secondary'"
        :disabled="!isValid"
      >
        Próximo
        <i class="icon-angle-right ml-3" />
      </button>
      <div class="m-3"></div>
      <button
        type="button"
        class="btn btn-outline-secondary btn-block"
        @click="$emit('cancel')"
      >
        Cancelar
      </button>
    </div>
  </form>
</template>
<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isValid() {
      return (
        this.form.email_support &&
        this.form.statement_descriptor &&
        !this.invalidDesc
      );
    },
    invalidDesc() {
      return (
        this.form.statement_descriptor &&
        (this.form.statement_descriptor.length > 13 ||
          /[^a-zA-Z0-9 ]/.exec(this.form.statement_descriptor))
      );
    },
    descErrors() {
      if (this.invalidDesc) {
        return [
          "Tamanho máximo 13 caracteres, não pode usar caracteres especiais e nem acentos."
        ];
      }
      return this.errors.statement_descriptor;
    }
  }
};
</script>
<style lang="scss" scoped>
.selling-data {
  .card {
    width: fit-content;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    strong {
      font-weight: 500;
    }
  }
  i {
    font-size: 24px;
  }
}
</style>
